import { IUpdateInspecaoObraUseCase } from "../../../presentation/useCases/update/update_inspecao_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateInspecaoObraUseCase
 */

export class UpdateInspecaoObraUseCase implements IUpdateInspecaoObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateInspecaoObra(
    idInspecaoObra: number,
    data: Date,
    campo1: string | null,
    campo2: string | null,
    campo3: string | null,
    campo4: string | null,
  ): Promise<void> {
    await this.repository.updateInspecaoObra(
      idInspecaoObra,
      data,
      campo1,
      campo2,
      campo3,
      campo4,
    );
  }
}
